<template>
  <el-link
    :style="estiloLink"
    :underline="false"
    class="download-button-base"
    :class="{'button-default-disabled': disabled}"
    @click="click"
  >
    <i
      v-if="iconePre"
      :class="iconePre"
      :style="estiloLink"
    />
    {{ texto }}
    <i
      v-if="iconePos"
      :class="iconePos"
      :style="estiloLink"
    />
  </el-link>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ButtonLink',
  props: {
    texto: {
      type: String,
      default: 'Click'
    },
    iconePos: {
      type: String,
      default: ''
    },
    iconePre: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    primaria: {
      type: Boolean,
      default: false
    },
    secundaria: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    cor () {
      if (this.secundaria) {
        return this.estilo.aplicacao.corSecundariaAplicacao
      }
      if (this.primaria) {
        return this.estilo.aplicacao.corPrimariaAplicacao
      }
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    estiloLink () {
      const style = {
        'color': `${this.cor} !important`
      }

      if (this.border) {
        style.border = `1px solid ${this.cor} !important`
        style['border-radius'] = `4px`
      }

      return style
    }
  },
  methods: {
    click () {
      if (this.disabled) {
        return
      }
      this.$emit('click')
    }
  }
}
</script>
